<template>
  <div v-if="!hide" class="cart-dropdown">
    <a href="/view-cart"
       class="cart-dropdown-icon"
       title="View cart">
      <img
        :src="staticUrl('img/client/icon-cart.png')"
        alt="user"
        class="icon"
      >
      <span class="cart-info">
                    <span v-if="!cartLoading" class="cart-qty">
                      {{getLocalCartProductsCount}}
                    </span>
                    <span v-else class="cart-qty"><i
                        class="fa fa-spinner fa-spin"></i><span
                        class="sr-only">Loading...</span></span>
                </span>
    </a>

    <div v-if="showCart" class="cart-dropdownmenu right">
      <div v-if="getLocalCartProductsCount > 0" class="dropdownmenu-wrapper">

        <div class="cart-totals">
          Total:
          <base-price :price="cartTotal()"></base-price>
        </div>

        <order-minimum/>

        <div class="cart-actions" v-if="!saveForLater">
          <a href="/view-cart" class="btn btn-grey">View Cart</a>

          <a v-if="isOverMinimum" href="/checkout" class="btn btn-primary">Checkout</a>
          <a v-else disabled href="/checkout" class="btn btn-primary disabled">Checkout</a>

        </div>

        <div class="cart-products">
            <cart-dropdown-item-display
                v-for="product in getDisplayedProducts"
                class="product product-sm"
                :product="product"
                :key="'cart-dropdown'+product.url">
              <button
                  @click="removeProductFromCartDropdown(product.stock_number)"
                  class="btn btn-remove" title="Remove Product">
                            <i class="fa fa-times"></i>
                        </button>
            </cart-dropdown-item-display>
          <div v-if="getLocalCartProductsCount>3">
            <strong>{{getLocalCartProductsCount - 3}} additional
              item{{pluralAdditionalItems}} in your cart...</strong>
          </div>
        </div>
        <div class="cart-actions save-data" v-if="isLoggedIn">
          <template v-if="saveForLater===true">
            <span class="inline-form">
              <div class="form-group">
                <label for="saveCurrentForLater">Description: </label>
                <input id="saveCurrentForLater"
                       type="text"
                       class="form-control"
                       autofocus="true"
                       v-model="cartDescription">
              </div>
              <button class="btn btn-xs btn-success"
                      @click="saveDescription">
                Save
              </button>
              <button @click="cancelDescription"
                      class="btn btn-xs btn-danger">
                Cancel
              </button>
            </span>
          </template>
          <template v-else-if="saveForLater==='saving'">
            <loading></loading>
          </template>
          <template v-else>
            <div class="save-later">{{getLocalCartObject.description}}</div>
            <a href="#"
               class="save-later"
               @click.prevent="editDescription">
              Edit your cart's description
            </a>
          </template>
        </div>
      </div>
      <div v-else class="dropdownmenu-wrapper">
        <div class="cart-empty">
          <h2>Your cart is empty...</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  import {getCartThumbnail, debugLog, staticUrl} from '^/utils'
  import Loading from 'vue-src/components/global/loading'
  import CartDropdownItemDisplay from 'vue-src/base/cart-dropdown-item-display'
  import OrderMinimumMixin from "vue-src/components/checkout/order-minimum-mixin";

  const OrderMinimum = () => ({
    component: import("vue-src/components/checkout/order-minimum"),
  })

  export default {
    name: 'cart-dropdown',
    data() {
      return {
        hiddenPages: [
          'view-cart',
          'checkout',
          'logout'
        ],
        saveForLater: false,
        cartDescription: '',
      }
    },
    mixins: [OrderMinimumMixin],
    computed: {
      getDisplayedProducts() {
        return this.getLocalCartObject.lineitems_recent
      },
      pluralAdditionalItems() {
        return this.getLocalCartProductsCount - 3 > 1 ? 's' : ''
      },
      hide() {
        /* Someone has a chrome extension with malware that overwrites the RegExp
           Contructor, because javascript. So we are rewriting this to not use
           RegExp. It's probably more efficient this way too.
         */

        let path = window.location.pathname
        for (let page in this.hiddenPages) {
          if (path.indexOf(this.hiddenPages[page]) >= 0) {
            return true
          }
        }
        return !this.$hasScope('cart.read', 'cart.write')
      },
      ...mapGetters([
        'getLocalCartProductsCount',
        'getLocalCartSubTotal',
        'getLocalCartObject',
        'cartLoading',
        'showCart',
        'isLoggedIn',
      ])
    },
    methods: {
      getProductThumbnail(product) {
        return getCartThumbnail(product)
      },
      checkRoute() {

      },
      async saveDescription(event) {
        this.saveForLater = 'saving'
        let result = await this.patchCart({description: this.cartDescription})
        if (result.status === 200) {
          this.saveForLater = false
        }
      },
      cancelDescription(event) {
        this.saveForLater = false
      },
      editDescription(event) {
        this.cartDescription = this.getLocalCartObject.description
        this.saveForLater = true
      },
      cartTotal() {
        return this.getLocalCartSubTotal
      },
      ...mapMutations([
        'setCartDescription'
      ]),
      ...mapActions([
        'removeProductFromCartDropdown',
        'patchCart',
        'emptyCart'
      ]),
      staticUrl(val) {
        return staticUrl(val)
      }
    },
    filters: {
      parseFloat,
      parseInt
    },
    components: {
      Loading,
      CartDropdownItemDisplay,
      OrderMinimum,
    },
    beforeCreate() {
      if (!this.$store.getters.cartLoading) {
        debugLog('DropdownLoading')
        // this.$store.dispatch('refreshCartObject')
      }
    },
  }
</script>

<style scoped>
  .btn-remove{
    border-color:transparent;
    background-color: transparent;
  }
</style>
<style>
  #header .cart-dropdown .cart-dropdown-icon .cart-info {
    position: absolute;
    width: auto;
    min-width: 16px;
    height: 16px;
    text-align: center;
    top: -4px;
    left: auto;
    margin-top: 0px;
    right: -4px;
    padding: 1px 4px;
    display: block;
    line-height: 11px;
    background: #737373;
    border-radius: 8px;
  }

  #header .cart-dropdown .cart-dropdown-icon .cart-qty i {
    font-size: 14px;
    color: #FFFFFF;
  }

  .cart-actions.save-data {
    text-align: center;
  }

  #header .cart-dropdown .cart-dropdownmenu .cart-actions .save-later {
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// ixcms/themes/gunoldcan/src/vue-src/top-level/cart-dropdown.vue